import React, { FC, useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';
import { userStore } from '../mobx/userStore';
import { keikkariScopeStore } from '../mobx/keikkariScopeStore';
import { Select } from './inputs';

const Container = styled.div`
  white-space: nowrap;
`;
export const ShowTeam: FC = observer(() => {
  const { t } = useTranslation();
  const { user, token } = userStore;
  const { team } = user || {};

  useEffect(() => {
    if (token && user?.role === 'staff') {
      keikkariScopeStore.ensureLoaded();
    }
  }, [token, user?.id, user?.teamId, user?.team?.likeitEmployeeId]);

  if (!team) {
    return null;
  }

  if (keikkariScopeStore.selectOptions.length > 1) {
    return (
      <Container>
        <Select
          id="keikkari-scope-select"
          label={t('team')}
          options={keikkariScopeStore.selectOptions}
          selected={keikkariScopeStore.selectedOption}
          onChange={(option: SelectedOption<string>) => keikkariScopeStore.setSelected(option?.value)}
          isClearable={false}
        />
      </Container>
    );
  }

  return (
    <Container>
      <div>{t('team')}</div>
      <b>{keikkariScopeStore.label || team.name}</b>
    </Container>
  );
});
